import React from 'react';

const DetailTitle = ({ title }) => {
  return (
    <div className='level-left'>
      <div className='level-item is-size-5 has-text-weight-semibold has-text-info'>
        {title}
      </div>
    </div>
  );
};

export default DetailTitle